import { isJSON } from './index';

export function setUser(data) {
  if (isJSON(data)) {
    localStorage.setItem('User', data);
  } else {
    localStorage.setItem('User', JSON.stringify(data));
  }
}

export function getUser() {
  const data = localStorage.getItem('User') || null;
  return data != null ? JSON.parse(data) : data;
}

export function removeUser() {
  localStorage.removeItem('User');
}

export function setLoginErr(num) {
  localStorage.setItem('LoginErr', num);
}

export function getLoginErr() {
  const data = localStorage.getItem('LoginErr') || null;
  return data != null ? Number(data) : 0;
}

export function removeLoginErr() {
  localStorage.removeItem('LoginErr');
}

export function setUUid(uuid) {
  localStorage.setItem('UUID', uuid);
}

export function getUUid() {
  const data = localStorage.getItem('UUID') || null;
  return data;
}

export function removeUUid(){
  localStorage.removeItem('UUID');
}